import { UserCountItem } from "interface/admin/interface.dashboard";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import {
  ChartItemWrap,
  PieChartBarWrap,
  PieChartBox,
  PieChartLegendWrap,
} from "style/admin/dashboard";
import { AGE_GROUPS } from "utils/datas";

interface DataProps {
  data: UserCountItem[];
}

const DashboardChartPie = ({ data }: DataProps) => {
  const totalMale = data.reduce((sum, item) => sum + (item.maleCount || 0), 0);
  const totalFemale = data.reduce(
    (sum, item) => sum + (item.femaleCount || 0),
    0
  );

  const total = totalMale + totalFemale;

  const malePercent = Math.round((totalMale / total) * 100);
  const femalePercent = 100 - malePercent;

  const genderPieData = [
    { name: "남자", value: totalMale },
    { name: "여자", value: totalFemale },
  ];

  const ageGenderData = AGE_GROUPS.map(({ label, key }) => {
    const item = data.find((d) => d.ageGroup === key);
    const male = item?.maleCount || 0;
    const female = item?.femaleCount || 0;
    return {
      label, // '10대' 등
      male,
      female,
    };
  });

  return (
    <PieChartBox>
      <ChartItemWrap>
        <h4>성별 및 연령별 분포</h4>
        {/* Legend */}
        <PieChartLegendWrap>
          {/* 남자 */}
          <div className="inner">
            <strong>{malePercent}%</strong>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "4px",
              }}
              className="item-boxs"
            >
              <div className="man box" />
              <span>남자</span>
            </div>
          </div>

          {/* 여자 */}
          <div className="inner">
            <strong>{femalePercent}%</strong>
            <div className="item-boxs">
              <div className="woman box" />
              <span>여자</span>
            </div>
          </div>
        </PieChartLegendWrap>
        <ResponsiveContainer width="100%" height={140}>
          <PieChart>
            <Pie
              data={genderPieData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="100%"
              startAngle={180}
              endAngle={0}
              innerRadius={70}
              outerRadius={110}
            >
              <Cell fill="#5B93FF" /> {/* 남자 */}
              <Cell fill="#F27496" /> {/* 여자 */}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <PieChartBarWrap>
          {ageGenderData.map((row, idx) => {
            const malePercent = totalMale
              ? Math.round((row.male / totalMale) * 100)
              : 0;
            const femalePercent = totalFemale
              ? Math.round((row.female / totalFemale) * 100)
              : 0;

            return (
              <div key={idx} className="items">
                {/* 왼쪽 퍼센트 */}
                <div className="left-txt">{malePercent}%</div>

                {/* 왼쪽 막대 */}
                <div className="left-bar">
                  <div
                    style={{
                      width: `${malePercent}%`,
                      backgroundColor: "#5B93FF",
                      height: "100%",
                    }}
                  />
                </div>

                {/* 연령대 라벨 */}
                <div className="center-txt">{row.label}</div>

                {/* 오른쪽 막대 */}
                <div className="right-bar">
                  <div
                    style={{
                      width: `${femalePercent}%`,
                      backgroundColor: "#F27496",
                      height: "100%",
                    }}
                  />
                </div>

                {/* 오른쪽 퍼센트 */}
                <div className="right-txt">{femalePercent}%</div>
              </div>
            );
          })}
        </PieChartBarWrap>
      </ChartItemWrap>
    </PieChartBox>
  );
};

export default DashboardChartPie;
